import { Spinner } from '@Components/common/Spinner';
import Empty from '@Components/ProfilePage/ِEmpty';
import ProgressBar from '@Components/ProgressBar';
import ReviewCard from '@Components/ReviewCard';
import { calculateFiveStarRating, calculateTotalReviews } from '@Utils/Rating';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Star from 'public/rate.svg';
import Arrow from 'public/show-arrow.svg';
import { useMemo, useState } from 'react';
import { APIResponse } from 'types/APIResponse';
import { Rate } from 'types/Rate';
import { Review } from 'types/Review';
import {
  Number,
  People,
  RatingNumber,
  RatingWrapper,
  ReviewListHeader,
  ReviewsList,
  ReviewsNumber,
  Section,
  SectionTitle,
  ShowMore,
  ShowMoreArrow,
} from './ProductReviewsSection.styled';

type Props = {
  reviewData: APIResponse<Review[]>;
  rateData: Rate;
};

export default function ProductReviewsSection({ reviewData: notFilteredReviewData, rateData }: Props) {
  const { t } = useTranslation('Product');
  const [limit, setLimit] = useState(4);
  const reviewData = notFilteredReviewData?.results.filter((review) => Boolean(review.comment.length));

  const totalReviews = useMemo(() => rateData && calculateTotalReviews(rateData), [rateData]);

  return reviewData?.length ? (
    <>
      <SectionTitle>{t('customer_reviews')}</SectionTitle>
      <Section>
        {!reviewData ? (
          <Spinner style={{ margin: 'auto' }} />
        ) : (
          <>
            <ReviewsList>
              {reviewData.length ? (
                <>
                  <ReviewListHeader>
                    <ReviewsNumber>
                      {reviewData.length} {t('reviews_number')}
                    </ReviewsNumber>
                  </ReviewListHeader>
                  {reviewData.slice(0, limit).map((card, index) => (
                    <ReviewCard key={index} data={card} />
                  ))}

                  {limit === 4 ? (
                    <ShowMore onClick={() => setLimit(reviewData.length)}>
                      {t('more_reviews')}
                      <ShowMoreArrow>
                        <Image src={Arrow} width={7.4} height={12} alt="arrow" />
                      </ShowMoreArrow>
                    </ShowMore>
                  ) : (
                    <ShowMore onClick={() => setLimit(4)}>
                      {t('less_reviews')}
                      <ShowMoreArrow>
                        <Image src={Arrow} width={7.4} height={12} alt="arrow" />
                      </ShowMoreArrow>
                    </ShowMore>
                  )}
                </>
              ) : (
                <Empty icon={Star} title={t('waiting_reviews')} noSpace />
              )}
            </ReviewsList>
            {reviewData && totalReviews && (
              <RatingWrapper>
                <Number>{calculateFiveStarRating(rateData)}</Number>
                <RatingNumber>
                  {calculateTotalReviews(rateData)} {t('reviews_number')}
                </RatingNumber>
                <People>{t('people_says')}</People>
                <ProgressBar number={5} percentage={rateData && rateData?.five_start / totalReviews} />
                <ProgressBar number={4} percentage={rateData && rateData?.four_start / totalReviews} />
                <ProgressBar number={3} percentage={rateData && rateData?.three_start / totalReviews} />
                <ProgressBar number={2} percentage={rateData && rateData?.two_start / totalReviews} />
                <ProgressBar number={1} percentage={rateData && rateData?.one_start / totalReviews} />
              </RatingWrapper>
            )}
          </>
        )}
      </Section>
    </>
  ) : (
    <></>
  );
}
